import { Route, Switch, useHistory } from 'react-router-dom';
import { MY_APPS_ROUTES } from '../config/routes';
import { LoadingScreen } from 'features/common/components/LoadingScreen';
import { getBaseMarketplaceAppUrl } from 'features/marketplace/config/env';
import { fetchLastSuccessfulLoginOrganizationId } from 'features/common/auth/auth0Storage';
import { useFetchTenantsData } from 'features/developer/core/auth/hooks/useFetchTenantsData';
import { useEffect } from 'react';
import { IframeWithNavigationSync } from 'features/common/components/IframeWithNavigationSync';

export const MyAppsRoutes: React.FC = () => {
  const history = useHistory();

  const { tenantsData, isLoading: tenantsLoading } = useFetchTenantsData();

  // Clean up URL by removing id and appId parameters when navigating to My Apps
  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    if (searchParams.has('appId') || searchParams.has('id')) {
      searchParams.delete('appId');
      searchParams.delete('id');
      const newSearch = searchParams.toString();
      const newUrl = newSearch
        ? `${history.location.pathname}?${newSearch}`
        : history.location.pathname;
      history.replace(newUrl);
    }
  }, [history]);

  if (tenantsLoading) {
    return <LoadingScreen data-testid='loading-component' message='Loading…' />;
  }

  const marketplaceTenant = tenantsData[0]?.id;

  const organizationId = fetchLastSuccessfulLoginOrganizationId();
  const marketplaceAppUrl = getBaseMarketplaceAppUrl();
  const myAppsHomepageUrl = `${marketplaceAppUrl}/my-apps/?organization=${organizationId}&tenantId=${marketplaceTenant}`;

  return (
    <Route path={MY_APPS_ROUTES.ROOT}>
      <Switch>
        <Route
          exact
          path={`${MY_APPS_ROUTES.ROOT}`}
          render={() => (
            <IframeWithNavigationSync
              src={myAppsHomepageUrl}
              title='My apps Homepage Iframe'
              allow='clipboard-read; clipboard-write'
              debugMode={process.env.NODE_ENV === 'development'}
            />
          )}
        />
      </Switch>
    </Route>
  );
};
